import React from "react";

import CallLogTable from '../callLogs/Table'
import { useHouseholdCallogs } from "../../apis";

const HouseholdCallLogs = ({household}) => {    
    const householdId = household.id
    const {callLogs,isLoading,isError} = useHouseholdCallogs(householdId)

    return (
        <>
            {!!isError && <div role="alert">The call history could not be loaded.</div>}
            <CallLogTable title="Call History" loading={isLoading && !isError} callLogs={callLogs} hideActions /*loadCallerCallLogs={loadCallerCallLogs}*/ />
        </>
    )
}

export default HouseholdCallLogs
